const TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
export const base64Encode = function(input) {
  input = String(input);
  let padding = input.length % 3;
  let output = '';
  let position = -1;
  let a;
  let b;
  let c;
  let buffer;
  // Make sure any padding is handled outside the loop.
  let length = input.length - padding;

  while (++position < length) {
    // Read three bytes, i.e. 24 bits.
    a = input.charCodeAt(position) << 16;
    b = input.charCodeAt(++position) << 8;
    c = input.charCodeAt(++position);
    buffer = a + b + c;
    // Turn the 24 bits into four chunks of 6 bits each, and append the
    // matching character for each of them to the output.
    output += (
      TABLE.charAt(buffer >> 18 & 0x3F) +
      TABLE.charAt(buffer >> 12 & 0x3F) +
      TABLE.charAt(buffer >> 6 & 0x3F) +
      TABLE.charAt(buffer & 0x3F)
    );
  }

  if (padding === 2) {
    a = input.charCodeAt(position) << 8;
    b = input.charCodeAt(++position);
    buffer = a + b;
    output += (
      TABLE.charAt(buffer >> 10) +
      TABLE.charAt((buffer >> 4) & 0x3F) +
      TABLE.charAt((buffer << 2) & 0x3F) +
      '='
    );
  } else if (padding === 1) {
    buffer = input.charCodeAt(position);
    output += (
      TABLE.charAt(buffer >> 2) +
      TABLE.charAt((buffer << 4) & 0x3F) +
      '=='
    );
  }

  return output;
};